<template>
	<TeamStatusControl @subcommand="subcommand" :subject="slide.settings.subject" type="answers"></TeamStatusControl>
</template>

<script>
import BaseSlide from './BaseSlide';
import TeamStatusControl from '../controls/TeamStatusControl';

export default {
	name: 'TeamQuestionSlide',
	mixins: [BaseSlide],
	components: {
		TeamStatusControl,
	},
};
</script>

<style scoped></style>
